if ($('.location__filters').length > 0) {

    filter_locations();
    mark_filters();

    /**
     * Filter buttons - click event listener
     */
    $('.location__filters ul li button').click(function() {

        $(this).toggleClass('active');

        let $this   = $(this),
            type    = $this.attr('data-type'),
            value   = $this.attr('data-value'),
            active = ($this.hasClass('active')) ? true : false,
            addremove = (active) ? "add" : "remove";

        add_param_to_url(type, value, addremove);
        filter_locations();
    });

    /**
     * Adding or Removing parameters from URL
     *
     * @param {} type
     * @param {*} value
     * @param {*} addremove
     */
    function add_param_to_url(type, value, addremove)
    {
        let url = new URL(window.location.href),
            tags = url.searchParams.get("tags"),
            cats = url.searchParams.get("cats");

        if (addremove == "add") {
            if (type == "category" && cats == null) {
                set_url_params('cats', value);
            } else if (type == "category" && !cats.includes(value)) {
                cats = cats + "," + value;
                set_url_params('cats', cats);
            } else if (type == "tag" && tags == null) {
                set_url_params('tags', value);
            } else if (type == "tag" && !tags.includes(value)) {
                tags = tags + "," + value;
                set_url_params('tags', tags);
            }
        } else if (addremove == "remove") {

            cats = (!!cats) ? cats.split(',') : false;
            tags = (!!tags) ? tags.split(',') : false;

            if (type == "category" && cats && cats.includes(value)) {
                if (cats.indexOf(value) !== -1) { cats.splice(index, 1); }
                cats = cats.join(',');
                url.searchParams.delete('cats');
                set_url_params('cats', cats);
            } else if (type == "tag" && tags && tags.includes(value)) {
                if (tags.indexOf(value) !== -1) { tags.splice(index, 1); }
                tags = tags.join(',');
                url.searchParams.delete('tags');
                set_url_params('tags', tags);
            }
        }
    }

    function mark_filters()
    {
        let url = new URL(window.location.href),
            tags = url.searchParams.get("tags"),
            cats = url.searchParams.get("cats");

        tags = (typeof tags !== "undefined" && !!tags) ? tags.split(",") : "";
        cats = (typeof cats !== "undefined" && !!cats) ? cats.split(",") : "";

        $.each($('.locations__filters-grid ul li'), function(index, item) {
            let $button = $(item).find('button'),
                button_type = $button.attr('data-type'),
                button_val = $button.attr('data-value');

            if (button_type == "category") {
                if (typeof cats !== "undefined" && !!cats && cats.includes(button_val)) {
                    if (!$button.hasClass('active')) { $button.addClass('active'); }
                }
            } else if (button_type == "tag") {
                if (typeof tags !== "undefined" && !!tags && tags.includes(button_val)) {
                    if (!$button.hasClass('active')) { $button.addClass('active'); }
                }
            }
        });
    }

    /**
     * Filtering locations by tags and categories
     */
    function filter_locations()
    {
        let url = new URL(window.location.href),
            tags = url.searchParams.get("tags"),
            cats = url.searchParams.get("cats"),
            filter = false;

        $('.archive__locations .articles .single__article').fadeOut('fast').removeClass('filteredIn').removeClass('filteredOut');

        if ( typeof tags !== "undefined" && !!tags ) {

            tags = tags.split(",");

            $.each(tags, function(index, tag) {

                $.each($('.archive__locations .articles .single__article'), function(index, article) {

                    let $article = $(article);

                    if (!$article.hasClass('filteredOut')) {

                        if ($article.attr('data-tags').indexOf(tag) < 0) {
                            $article.addClass('filteredOut').fadeOut('fast');
                        } else {
                            $article.addClass('filteredIn').fadeIn();
                        }
                    }
                });
            });

            filter = true;
        }

        if ( typeof cats !== "undefined" && !!cats ) {

            cats = cats.split(",");

            $.each(cats, function(index, cat) {

                $.each($('.archive__locations .articles .single__article'), function(index, article) {

                    let $article = $(article);

                    if (!$article.hasClass('filteredOut')) {
                        if ($article.attr('data-cats').indexOf(cat) < 0) {
                            $article.addClass('filteredOut').fadeOut('fast');
                        } else {
                            $article.addClass('filteredIn').fadeIn();
                        }
                    }
                });
            });

            filter = true;
        }

        if (!filter) { $('.archive__locations .articles .single__article').fadeIn('fast'); }
    }
}

/**
 * Setting parameters to URL and changing the state
 * @param {*} name
 * @param {*} value
 */
function set_url_params(name, value)
{
    let url = new URL(window.location.href)
    url.searchParams.set(name, value);
    window.history.replaceState(null, null, url);
}